/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Upload_HintInputs */

const en_cv_check_upload_hint = /** @type {(inputs: Cv_Check_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload your resume as a PDF to receive feedback.`)
};

const de_cv_check_upload_hint = /** @type {(inputs: Cv_Check_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade deinen Lebenslauf als PDF hoch, um Feedback zu erhalten.`)
};

/**
* | output |
* | --- |
* | "Upload your resume as a PDF to receive feedback." |
*
* @param {Cv_Check_Upload_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_upload_hint = /** @type {((inputs?: Cv_Check_Upload_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Upload_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_upload_hint(inputs)
	return en_cv_check_upload_hint(inputs)
});